<div class="overlay" *ngIf="isLoading">
    <div class="loader"></div>
</div>
